import type { SelectProps } from "../Select/types";

export const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"] as const;

export type Weekday = typeof weekdays[number];

type DistributiveOmit<T, K extends keyof any> = T extends any ? Omit<T, K> : never;

export type WeekdaySelectProps = DistributiveOmit<SelectProps<Weekday>, "children">;
